import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetSettlementsQuery,
  usePublicGetSettlementsQuery,
  useGetSettlementsDefaultsQuery,
  usePublicGetSettlementsDefaultsQuery,
  useGetRoadsQuery,
  usePublicGetRoadsQuery,
  useGetBuildingsQuery,
  usePublicGetBuildingsQuery,
  useGetOthersQuery,
  usePublicGetOthersQuery,
} from '../features/modules/settlementsApislice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting settlements data based on the current route.
 */
export const useContextAwareGetSettlements = createContextAwareHook(
  useGetSettlementsQuery,
  usePublicGetSettlementsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting settlements defaults based on the current route.
 */
export const useContextAwareGetSettlementsDefaults = createContextAwareHook(
  useGetSettlementsDefaultsQuery,
  usePublicGetSettlementsDefaultsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting roads data based on the current route.
 */
export const useContextAwareGetRoads = createContextAwareHook(
  useGetRoadsQuery,
  usePublicGetRoadsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting buildings data based on the current route.
 */
export const useContextAwareGetBuildings = createContextAwareHook(
  useGetBuildingsQuery,
  usePublicGetBuildingsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting other infrastructure data based on the current route.
 */
export const useContextAwareGetOthers = createContextAwareHook(
  useGetOthersQuery,
  usePublicGetOthersQuery
);

// Re-export mutation hooks directly from the API slice
export {
  useUpdateSettlementsMutation,
  useCreateRoadsMutation,
  useDeleteRoadsMutation,
  useUpdateRoadsMutation,
  useCreateBuildingsMutation,
  useDeleteBuildingsMutation,
  useUpdateBuildingsMutation,
  useCreateOthersMutation,
  useDeleteOthersMutation,
  useUpdateOthersMutation,
} from '../features/modules/settlementsApislice';
